module.exports = __webpack_public_path__ + "img/1.bb5631df.png";